// extracted by mini-css-extract-plugin
export default {"wrap":"zoom___wrap___f70e5786","push":"zoom___push___e02af08a","box":"zoom___box___a22da0a7","range":"zoom___range___e6b30667","text":"zoom___text___c5a71f9e"};